/* eslint-disable react/jsx-no-bind */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as accountActions from '../../actions/accountActions';
import MetaTags from 'react-meta-tags';
import PageLoading from '../common/PageLoading';
import * as qs from 'query-string';
import * as browserCheck from '../../utils/browserCheck.js';
import ToastrService from '../../services/toastrService';
import ChangePassword from './ChangePassword';
import SetPassword from './SetPassword';
import Loading from '../common/Loading';

class AccountSettingsPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.getExternalLogins = this.getExternalLogins.bind(this);
        this.getExternalLoginsList = this.getExternalLoginsList.bind(this);
        this.removeExternalLogin = this.removeExternalLogin.bind(this);
        this.externalLogin = this.externalLogin.bind(this);
        this.checkForExternalLoginCallback = this.checkForExternalLoginCallback.bind(this);
        this.setPasswordSuccess = this.setPasswordSuccess.bind(this);
        this.getExternalLoginImageSrc = this.getExternalLoginImageSrc.bind(this);
        this.state = {          
            loading: this.checkForExternalLoginCallback(),
            externalLogins: [],
            externalLoginsList: [],
            loadingExternalLogins: false,
            loadingExternalLoginsList: false
        };         
    }

    componentWillMount() {
        this.getExternalLogins();
        this.getExternalLoginsList();
    }

    componentDidMount() {  
        if (browserCheck.canUseDom()) {
            window.componentHandler.upgradeDom(); 
        }    
    }

    externalLogin(event, provider) {
        event.preventDefault();
        let login;
        if(this.state.externalLoginsList.length) {
            login = this.state.externalLoginsList.find(l => l.Name === provider);
        }
        if(login) {
            window.location = `${login.Url}`;
        }        
    }

    getExternalLoginsList() {
        if(!this.state.externalLoginsList.length) {
            this.setState({ loadingExternalLoginsList: true });
            //add a trailing slash after the url as otherwise, Safari will strip the oauth fragment added to the url after the #
            let pathname = window.location.pathname;
            if(pathname[pathname.length - 1] !== '/') {
                pathname = pathname + '/';
            }
            this.props.actions.getExternalLoginsList(pathname)
                .then(logins => {                   
                    this.setState({
                        externalLoginsList: logins.filter(l => l.Name !== 'SoundCloud' && l.Name !== 'Apple'), //we can reenable Apple once the app is running and we've tested it
                        loadingExternalLoginsList: false
                    });
                })
                .catch(error => {
                    this.setState({ loadingExternalLoginsList: false });
                });
        }
    }

    getExternalLogins(forceReload = false) {
        if(!this.state.externalLogins.length || forceReload) {
            this.setState({ loadingExternalLogins: true });
            this.props.actions.getExternalLogins()
                .then(logins => {                    
                    this.setState({
                        externalLogins: logins,
                        loadingExternalLogins: false
                    });
                })
                .catch(error => {
                    this.setState({ loadingExternalLogins: false });
                });
        }
    }    

    checkForExternalLoginCallback() {
        let loading = false;
        const toastrService = new ToastrService();
        const hash = this.props.location.hash;
        let params = {};
        if(hash) {
            params = qs.parse(hash.substr(1));
        }        
        let accessTokenCookie = browserCheck.canUseDom() ? document.cookie
            .split('; ')
            .find(row => row.startsWith('AccessToken')) : null;
        let accessToken = accessTokenCookie ? accessTokenCookie.split('=')[1] : (params.access_token ? params.access_token : null);
        let expiresAtCookie = browserCheck.canUseDom() ? document.cookie
            .split('; ')
            .find(row => row.startsWith('ExpiresAt')) : null;
        let expires = expiresAtCookie ? decodeURIComponent(expiresAtCookie.split('=')[1]) : (params.expires_at ? params.expires_at : null);
        if(accessToken) {
            loading = true;
            //delete the token details from the cookie now we've read it (it's set to expire in 5 mins but let's be extra safe)
            const domain = window.location.hostname;
            document.cookie = `AccessToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC;Domain=${domain}`;
            document.cookie = `Expires=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC;Domain=${domain}`;
            //this was to clear the token from the url, we don't need it anymore as we're using cookies
            //window.history.replaceState(null, document.title, this.props.location.pathname + this.props.location.search);
            this.props.actions.getUserInfo(accessToken)
                .then(userInfo => {
                    if(userInfo) {
                        if(userInfo.HasRegistered) {                                
                            if(userInfo.ID !== this.props.user.ID) {
                                toastrService.showError('', 'This login is linked to a different LoudUp account, please try logging out and logging in using this login to access it', null, 6000); 
                            }
                            else {
                                //this shouldn't happen, if the user had already registered with this login, they shouldn't have had the option 
                                //except this page was stale. Just reload the logins.
                                toastrService.showSuccess('', `This ${userInfo.LoginProvider} login is already linked to your account`);  
                                this.getExternalLogins();   
                            }                                                           
                        }
                        else {
                            //add the external login
                            this.props.actions.addLogin(accessToken)
                                .then(_ => {
                                    this.getExternalLogins();
                                    toastrService.showSuccess('', `The ${userInfo.LoginProvider} login has been added to your account`); 
                                })
                                .catch(error => {
                                    toastrService.showError('', `Sorry, something went wrong, unable to add the ${userInfo.LoginProvider} login`);
                                });        
                        }
                        this.setState({
                            loading: false
                        });
                    }
                    else {
                        toastrService.showError('Social login failed', 'Sorry, it looks like your login attempt may have timed out, please try again');
                        this.setState({
                            loading: false
                        });
                        this.getExternalLogins();
                    }
                })
                .catch(error => {
                    this.setState({
                        loading: false
                    });
                });
        }
        else if(params.error) {
            toastrService.showError('Social login failed', 'Sorry, something went wrong, unable to complete login');
        }
        return loading;
    }

    onChange(event) {
        const field = event.target.name;
        const value = event.target.value;
        let newState = Object.assign({}, this.state);
		newState[field] = value;
		return this.setState(newState);
    }

    removeExternalLogin(event, login) {
        event.preventDefault();
        const toastrService = new ToastrService();
        this.props.actions.removeLogin(login.Provider, login.ProviderUserId)
            .then(_ => {                
                toastrService.showSuccess('', `The ${login.Provider} login has been removed successfully`);
                this.getExternalLogins(true);         
            })
            .catch(error => {
                toastrService.showError('', 'Sorry, something went wrong, unable to remove the login');
            });
    }

    setPasswordSuccess() {
        //reload the user - this should set the HasPassword flag to true
        this.props.actions.getUser();
        this.getExternalLogins(true);
    }

    getExternalLoginImageSrc(login) {
        if (login.Name === 'Facebook') {
            return require('../../images/btn-sociallog-fb.png');
        }
        else if (login.Name === 'Twitter') {
            return require('../../images/btn-sociallog-tw.png');
        }
        else {
            return require('../../images/btn-sociallog-apple.png');
        }
    }

    render() {
        return (            
            <div className="main">
                <MetaTags>
                    <title>Manage Account - LoudUp</title>
                </MetaTags> 
                {
                    !this.state.loading ?
                        <div className="container">
                            <div className="block-inner">
                                <div className="signupbox">
                                    <div className="signhead">
                                        <h1 className="section-alt">Manage Account</h1>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form form-horizontal">
                                                <p className="btn-simple text-center">You're logged in as <strong>{this.props.user.Email}</strong>.</p>
                                                <br />
                                                <div className="section-block">
                                                    {
                                                        this.props.user.HasLocalAccount ? 
                                                            <ChangePassword actions={this.props.actions} />
                                                            :
                                                            <SetPassword actions={this.props.actions} onSuccess={this.setPasswordSuccess} />
                                                    }
                                                </div>
                                                <div id="externalLogins" className="section-block">
                                                    {
                                                        this.state.externalLogins.length ?
                                                            <React.Fragment>
                                                                <h3 className="subsection">Registered external logins</h3>
                                                                <div className="table-info visible-xs">&#8592; SCROLLABLE &#8594;</div>
                                                                <div className="table-responsive">
                                                                    <table className="table table-results">
                                                                        <tbody>
                                                                            {
                                                                                this.state.externalLogins.map(login =>
                                                                                    <tr key={login.ProviderDisplayName}>
                                                                                        <td><strong>{login.ProviderDisplayName}</strong></td>
                                                                                        <td>(<a href={login.PageUrl} target="_blank">{login.UserDisplayName}</a>)</td>
                                                                                        <td>
                                                                                            {
                                                                                                login.AllowRemove ?
                                                                                                    <form onClick={(event) => this.removeExternalLogin(event, login)}>
                                                                                                        <fieldset style={{ border: 'none' }}>
                                                                                                            <input type="submit" value="Remove" className="btn btn-simple transition" title={`Remove this ${login.ProviderDisplayName} credential from your account`} />
                                                                                                        </fieldset>
                                                                                                    </form>
                                                                                                :
                                                                                                <span />

                                                                                            }
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            }
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                <br />
                                                            </React.Fragment>
                                                            : this.state.loadingExternalLogins ? <Loading /> : null
                                                    }
                                                    <h3 className="subsection">Add an external login</h3>
                                                        {
                                                            this.state.externalLoginsList.length ? 
                                                                <fieldset id="socialLoginList">
                                                                    <p className="text-center">Log in using an additional service</p>
                                                                    <p className="text-center">
                                                                        {
                                                                            this.state.externalLoginsList.filter(login => !this.state.externalLogins.find(l => l.ProviderDisplayName === login.Name)).map(login =>     
                                                                                <p key={login.Name} className="text-center">
                                                                                    <a href={null} style={{cursor: "pointer"}} onClick={(e) => this.externalLogin(e, login.Name)}>
                                                                                        <img src={this.getExternalLoginImageSrc(login)} width="240" height="41" alt={`Log in with ${login.Name}`} />
                                                                                    </a>
                                                                                </p>
                                                                            )
                                                                        } 
                                                                    </p>
                                                                </fieldset>
                                                            :
                                                                this.state.loadingExternalLoginsList ? 
                                                                <Loading /> 
                                                                : 
                                                                <div className="message-info">
                                                                    <p>There are no additional log in services</p>
                                                                </div>
                                                            
                                                        }
                                                </div>
                                                <br />
                                                <h3 className="subsection">Close Account</h3>
                                                <p className="text-center">
                                                    <Link to="/Account/Close" className="btn-simple transition">Close your LoudUp account</Link>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    :
                    <div>
                        <PageLoading />
                    </div>
                }                
            </div>                    
        );
    }
}

AccountSettingsPage.propTypes = {
    user: PropTypes.object,
    actions: PropTypes.object.isRequired,
    location: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return { user: state.account.user, loginError: state.account.loginError };
}

function mapDispatchToProps(dispatch) {
    return {
        //account actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, accountActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettingsPage);